import { DotOutline } from '@phosphor-icons/react';

export default DotOutline;
